import React, { useEffect, useState } from "react";
import L from "leaflet";
import { Circle, MapContainer, Marker, Polygon, TileLayer, Tooltip } from "react-leaflet";
import { CENTRO_DEFAULT, ZOOM_DEFAULT, ZOOM_CALLE, CAPA_OSM, areaALatLngs } from "./leafletConfig";

const MapaUbicacionChecada = ({ area, ubicacion, height = 350 }) => {
    const [mapa, setMapa] = useState(null);

    const latLngsArea = areaALatLngs(area);
    const punto = Number.isFinite(ubicacion?.lat) && Number.isFinite(ubicacion?.lng)
        ? [ubicacion.lat, ubicacion.lng]
        : null;
    const precision = Number(ubicacion?.precision);
    const tieneRadio = Number.isFinite(precision) && precision > 0;

    useEffect(() => {
        if (!mapa) return;
        const poligono = areaALatLngs(area);
        const hayPunto = Number.isFinite(ubicacion?.lat) && Number.isFinite(ubicacion?.lng);
        const radio = Number(ubicacion?.precision);

        const partes = [];
        if (poligono) partes.push(L.latLngBounds(poligono));
        if (hayPunto) {
            const centro = L.latLng(ubicacion.lat, ubicacion.lng);
            partes.push(Number.isFinite(radio) && radio > 0 ? centro.toBounds(radio * 2) : L.latLngBounds([centro, centro]));
        }
        if (!partes.length) return;

        const limites = partes.reduce((acumulado, parte) => acumulado.extend(parte));
        mapa.fitBounds(limites, { padding: [30, 30], maxZoom: ZOOM_CALLE });
    }, [mapa, area, ubicacion]);

    // Dentro de un modal el contenedor puede cambiar de tamaño después de montarse
    useEffect(() => {
        if (!mapa) return;
        const observador = new ResizeObserver(() => mapa.invalidateSize());
        observador.observe(mapa.getContainer());
        return () => observador.disconnect();
    }, [mapa]);

    return (
        <MapContainer
            center={punto || CENTRO_DEFAULT}
            zoom={punto ? ZOOM_CALLE : ZOOM_DEFAULT}
            style={{ height, width: "100%", borderRadius: 8 }}
            whenCreated={setMapa}
        >
            <TileLayer url={CAPA_OSM.url} attribution={CAPA_OSM.attribution} maxZoom={CAPA_OSM.maxZoom} />
            {latLngsArea && (
                <Polygon positions={latLngsArea} pathOptions={{ color: "#00BFD6", weight: 2, fillOpacity: 0.15 }} />
            )}
            {punto && tieneRadio && (
                <Circle center={punto} radius={precision} pathOptions={{ color: "#fd9e62", weight: 1, fillOpacity: 0.2 }} />
            )}
            {punto && (
                <Marker position={punto}>
                    <Tooltip>
                        {tieneRadio ? `Precisión GPS: ±${Math.round(precision)} m` : "Ubicación de la checada"}
                    </Tooltip>
                </Marker>
            )}
        </MapContainer>
    );
};

export default MapaUbicacionChecada;
